import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["status", "latency", "result", "button", "redisStatus"]

  // Action Cable retries an unconfirmed subscribe every 500ms, silently and forever.
  // Report if we have not been confirmed within this window.
  static CONFIRM_TIMEOUT_MS = 10000

  connect() {
    // Subscribe once on page load, like normal Action Cable usage
    this.subscription = consumer.subscriptions.create("TestChannel", {
      connected: this._cableConnected.bind(this),
      disconnected: this._cableDisconnected.bind(this),
      received: this._cableReceived.bind(this)
    })

    this.confirmTimer = setTimeout(() => {
      const message = `APcable TestChannel subscription not confirmed after ${this.constructor.CONFIRM_TIMEOUT_MS}ms`
      console.error(message)
      this.statusTarget.textContent = "Not confirmed"
      this.statusTarget.className = "badge bg-danger"
      window.airbrake?.notify({ error: new Error(message) })
    }, this.constructor.CONFIRM_TIMEOUT_MS)
  }

  disconnect() {
    clearTimeout(this.confirmTimer)
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  _cableConnected() {
    clearTimeout(this.confirmTimer)
    console.log("Connected to TestChannel")
    this.statusTarget.textContent = "✓ Connected"
    this.statusTarget.className = "badge bg-success"
    this.buttonTarget.disabled = false
  }

  _cableDisconnected() {
    console.log("Disconnected from TestChannel")
    this.statusTarget.textContent = "Disconnected"
    this.statusTarget.className = "badge bg-secondary"
  }

  _cableReceived(data) {
    if (data.type === 'pong') {
      const latency = Date.now() - data.client_timestamp

      this.latencyTarget.textContent = `${latency}ms`
      this.updateRedisStatus(data.redis_verified, data.redis_error)
      this.resultTarget.textContent = data.message
      this.resultTarget.className = data.redis_verified ? "alert alert-success" : "alert alert-warning"
      this.buttonTarget.disabled = false
    }
  }

  test() {
    this.buttonTarget.disabled = true
    this.latencyTarget.textContent = "—"
    this.resultTarget.textContent = ""
    this.resultTarget.className = ""

    // Send ping through existing subscription
    this.subscription.perform('ping', {
      timestamp: Date.now()
    })

    // Timeout after 5 seconds
    setTimeout(() => {
      if (this.buttonTarget.disabled) {
        this.resultTarget.textContent = "Test timeout - no response received"
        this.resultTarget.className = "alert alert-danger"
        this.buttonTarget.disabled = false
      }
    }, 5000)
  }

  updateRedisStatus(working, message) {
    if (working) {
      this.redisStatusTarget.textContent = "✓ Working"
      this.redisStatusTarget.className = "badge bg-success"
    } else {
      this.redisStatusTarget.textContent = "✗ Error"
      this.redisStatusTarget.className = "badge bg-danger"
      console.error("Redis test failed:", message)
    }
  }
}
